import component from './RedirectRulesForm.vue'
export default component
